import { useSelector } from 'react-redux';
import { RootState } from 'store/types';

export const useUser = () => {
  return useSelector((state: RootState) => state.auth.user);
};
